__turbopack_context__.v({
  "cta": "aVRe9W_cta",
  "duration": "aVRe9W_duration",
  "video": "aVRe9W_video",
});
